import { getEnvKey } from 'utils/getEnvValue';

import type { TemplateModelData } from 'types/types';

interface SpecialtyCount {
  title: string;
  count: number;
}

const envPrefix = getEnvKey({
  DEV: 'd79eef3bde0445518e995ef57333cd0d_',
  QA: '93aadb18021a441ba7c99eb365b6f7a1_',
  UAT: '28afc672302a4fae8b3988f7f7225dc1_',
  PROD: '',
});

const countSpecialties = (data: TemplateModelData[]): SpecialtyCount[] => {
  const specialtyMap = new Map<string, number>();

  data.forEach((item: TemplateModelData) => {
    const specialties = item?.data?.templateInfo?.filters?.specialty;

    if (Array.isArray(specialties)) {
      specialties.forEach((specialty: string) => {
        specialtyMap.set(specialty, (specialtyMap.get(specialty) || 0) + 1);
      });
    }
  });

  const result = Array.from(specialtyMap.entries())
    .map(
      ([title, count]): SpecialtyCount => ({
        title,
        count,
      }),
    )
    .sort((a, b) => a.title.localeCompare(b.title));

  return result;
};

const countTopics = (data: TemplateModelData[]): SpecialtyCount[] => {
  const specialtyMap = new Map<string, number>();

  data.forEach((item: TemplateModelData) => {
    const specialties = item?.data?.templateInfo?.filters?.topic;

    if (Array.isArray(specialties)) {
      specialties.forEach((specialty: string) => {
        specialtyMap.set(specialty, (specialtyMap.get(specialty) || 0) + 1);
      });
    } else if (typeof specialties === 'string' && specialties !== '') {
      specialtyMap.set(specialties, (specialtyMap.get(specialties) || 0) + 1);
    }
  });

  const result = Array.from(specialtyMap.entries())
    .map(
      ([title, count]): SpecialtyCount => ({
        title,
        count,
      }),
    )
    .sort((a, b) => a.title.localeCompare(b.title));

  return result;
};

const generateSidebarItems = (data: TemplateModelData[]) => {
  const articleTotal = data.filter(entry => entry.modelId === `${envPrefix}00ae5ef151ff4c9a84ef99e73386381f`).length;
  const claimsLessonTotal = data.filter(
    entry => entry.modelId === `${envPrefix}b28df6934c7b4d2d9007f285e766546f`,
  ).length;
  const videoTotal = data.filter(entry => entry.modelId === `${envPrefix}e50a3d2cacf04e43a3ee7537b0286cfd`).length;
  const podcastTotal = data.filter(entry => entry.modelId === `${envPrefix}4f3d4305f43646a4bb98b29a0705c311`).length;

  const retrieveSpecialties = countSpecialties(data);
  const retrieveTopics = countTopics(data);

  return [
    {
      heading: 'Content Type',
      content: [
        { title: 'Article', count: articleTotal },
        { title: 'Case Study', count: claimsLessonTotal },
        { title: 'Video', count: videoTotal },
        { title: 'Podcast', count: podcastTotal },
      ],
    },
    {
      heading: 'Specialty',
      content: retrieveSpecialties,
    },
    {
      heading: 'Subject Matter',
      content: retrieveTopics,
    },
  ];
};

export default generateSidebarItems;
